import { render } from "./SpeakerCardView.vue?vue&type=template&id=c2f2eb10&scoped=true"
import script from "./SpeakerCardView.vue?vue&type=script&lang=js"
export * from "./SpeakerCardView.vue?vue&type=script&lang=js"

import "./SpeakerCardView.vue?vue&type=style&index=0&id=c2f2eb10&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2f2eb10"]])

export default __exports__